import { ResponsiveProductImage } from "./ResponsiveProductImage";
import { useSelector } from "react-redux";
import {
  selectImageRotation,
  selectOwnerCode,
  selectResizeURL
} from "../store/orderingSlice";

export function ColorStyleSelectThumb({ styleItem, className = "thumbnail"  }) {
  const owner_code = useSelector(selectOwnerCode);
  const resize_url = useSelector(selectResizeURL);
  const image_rotation = useSelector(selectImageRotation);
  const size_breakpoints = {
    0: 64
  };
  const srcset_widths = [
    64,
    128
  ];
  const default_width = 64;
  return (
    <ResponsiveProductImage
      resizeURL={resize_url}
      path={owner_code + "-" + styleItem.style_item_code + "-1.jpg"}
      rotation={image_rotation}
      srcsetWidths={srcset_widths}
      sizeBreakpoints={size_breakpoints}
      defaultWidth={default_width}
      alt={styleItem.style_item_name}
      className={className} />
  );
}
